export default "__VITE_ASSET__CsvZgLbH__"